/*
 * Custom theme code, kept separate from theme.js (vendor-managed, overwritten on theme updates).
 */

const KLAVIYO_BACK_IN_STOCK_API_URL = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
const KLAVIYO_API_REVISION = '2026-07-15';

class NotifyMeForm extends HTMLElement {
  connectedCallback() {
    this.toggleButton = this.querySelector(':scope > button');
    this.panel = this.querySelector('.notify-me-form__panel');
    this.emailInput = this.panel.querySelector('input[type="email"]');
    this.submitButton = this.panel.querySelector('button');
    this.banner = this.querySelector('.notify-me-form__banner');

    this.toggleButton.addEventListener('click', () => this.showForm());
    this.submitButton.addEventListener('click', () => this.onSubmit());
    this.emailInput.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.onSubmit();
      }
    });
  }

  showForm() {
    this.toggleButton.hidden = true;
    this.panel.hidden = false;
    this.emailInput.focus();
  }

  async onSubmit() {
    if (!this.emailInput.checkValidity()) {
      this.showBanner(this.dataset.invalidEmailMessage, 'error');
      return;
    }

    this.submitButton.disabled = true;

    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: this.emailInput.value.trim()
              }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${this.dataset.variantId}`
            }
          }
        }
      }
    };

    const url = `${KLAVIYO_BACK_IN_STOCK_API_URL}?company_id=${encodeURIComponent(this.dataset.klaviyoPublicKey)}`;

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: KLAVIYO_API_REVISION
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error(`Klaviyo back in stock subscription failed with status ${response.status}`);
      }

      this.panel.hidden = true;
      this.showBanner(this.dataset.successMessage, 'success');
    } catch (error) {
      console.error(error);
      this.submitButton.disabled = false;
      this.showBanner(this.dataset.errorMessage, 'error');
    }
  }

  showBanner(message, status) {
    this.banner.textContent = message;
    this.banner.className = `notify-me-form__banner banner banner--${status}`;
    this.banner.hidden = false;
  }
}

if (!window.customElements.get('notify-me-form')) {
  window.customElements.define('notify-me-form', NotifyMeForm);
}
